import { HStack } from '@pets-ui/HStack/HStack'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { VStack } from '@pets-ui/VStack/VStack'

export const SkeletonCartListItem = () => {
  return (
    <HStack p={3} gap={2} alignItems="flex-start" width="100%">
      <Skeleton variant="rounded" height={96} width={96} />
      <VStack gap={1} flex={1}>
        <Skeleton variant="rounded" height={16} />
        <Skeleton variant="rounded" height={16} />
        <Skeleton variant="rounded" height={16} />
      </VStack>
    </HStack>
  )
}
